export const selectIsIntercomPopupInDOM = (state) => !!state.intercom.isIntercomPopupInDOM;
